import { CaseStyle, convertObjectKeysCase, isObject } from '../utils';
export var transformRequestMiddleware = function (request) {
    if (request.formData) {
        request.params =
            request.params && convertObjectKeysCase({ object: request.params });
        return request;
    }
    if (isObject(request)) {
        request.body =
            request.body && convertObjectKeysCase({ object: request.body });
        request.params =
            request.params && convertObjectKeysCase({ object: request.params });
        return request;
    }
    return request;
};
export var transformResponseMiddleware = function (response) {
    if (response.data instanceof Blob)
        return response;
    if (response.data) {
        response.data = convertObjectKeysCase({
            caseStyle: CaseStyle.CAMEL_CASE,
            object: response.data,
        });
    }
    return response;
};
export var transformErrorMiddleware = function (error) {
    return convertObjectKeysCase({
        caseStyle: CaseStyle.CAMEL_CASE,
        object: error,
    });
};
